import React from "react";
import { useSelector } from "react-redux";
import SupportLayout from "../support/SupportLayout";
import AdminAmbassadors from "./components/AdminAmbassadors";

const AdminAmbassadorsPage = ({ useLayout = true }) => {
  const userProfile = useSelector((state) => state.userProfile?.user);
  const userRole = userProfile?.role?.toUpperCase() || "ADMIN";

  const content = (
    <div className="pb-40">
      <AdminAmbassadors showHeader={true} />
    </div>
  );

  if (useLayout) {
    return <SupportLayout userRole={userRole}>{content}</SupportLayout>;
  }

  return content;
};

export default AdminAmbassadorsPage;
